import { EventReel } from "./EventReel";
import { Header } from "../../Header";
import { Footer } from "../../Footer";

export function AllEvents() {
    return (
    <main>
        <Header />
        <EventReel />
        <Footer />
    </main>
    )
}